import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import ColumnHeader from "./ColumnHeader";
import { minimizeChannel, maximizeChannel } from "actions/ui";

class Column extends React.Component {

	constructor(props) {
		super(props);
		
		this.isMinimized = this.isMinimized.bind(this);
		this.handleMinimizeToggle = this.handleMinimizeToggle.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	isMinimized() {
		if (!this.props.minimizable) {
			return false;
		}

		return this.props.minimizedChannels.includes(this.props.id);
	}

	handleMinimizeToggle() {
		if (this.isMinimized()) {
			this.props.maximizeChannel(this.props.id);
		} else {
			this.props.minimizeChannel(this.props.id);
		}
	}

	handleClick() {
		if (this.props.minimizable) {
			this.handleMinimizeToggle();
		}
	}

	render() {
		return <div className={ "wcColumn" + ( this.props.className ? ' ' + this.props.className : '' ) } onClick={ this.props.onClick ? this.props.onClick : e => {} }>
			<ColumnHeader
				id={ this.props.id }
				text={ this.props.title }
				minimizable={ this.props.minimizable }
				minimized={this.isMinimized()}
				onMaximize={this.handleMinimizeToggle}
				onMinimize={this.handleMinimizeToggle}
				onClick={ this.handleClick }
				closeButton={ this.props.closeButton }
				closable={ this.props.closable }
				unread={ this.props.unread }
				unreadNumber={ this.props.unreadNumber }
				contentElements={ this.props.headerContentElements }
			>
				{ this.props.headerElement }
			</ColumnHeader>
			<div className={ 'wcContent' + ( this.props.contentClassName ? ' ' + this.props.contentClassName : '' ) + (this.isMinimized() ? ' wcInvisible' : '') } style={ { backgroundColor: this.props.configuration.defaultBackgroundColor } }>
				{ this.props.children }
			</div>
		</div>
	}

}

Column.defaultProps = {
	closable: false,
	unread: false,
	minimizable: true,
	headerContentElements: []
}

Column.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	className: PropTypes.string,
	contentClassName: PropTypes.string,
	configuration: PropTypes.object.isRequired,
	headerElement: PropTypes.object,
	onClick: PropTypes.func,
	closeButton: PropTypes.object,
	closable: PropTypes.bool,
	unread: PropTypes.bool,
	unreadNumber: PropTypes.number,
	minimizable: PropTypes.bool,
	headerContentElements: PropTypes.array.isRequired
};

export default connect(
	(state) => ({
		configuration: state.configuration,
		minimizedChannels: state.ui.minimizedChannels
	}),
	{ minimizeChannel, maximizeChannel }
)(Column);